import { MenuItem, Select, Stack, Typography } from "@mui/material";

import { AGGREGATE_CARD_SORT_OPTIONS } from "./pricingReportAggregateSort";

/**
 * Card-view sort dropdown using the same sortable fields as the aggregate table.
 *
 * @param {{
 *   value: string,
 *   onChange: (signedHeaderId: string) => void,
 * }} props
 */
function PricingReportCardSortSelect({ value, onChange }) {
  const selectValue = AGGREGATE_CARD_SORT_OPTIONS.some((option) => option.value === value)
    ? value
    : AGGREGATE_CARD_SORT_OPTIONS[0].value;

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography sx={{ fontSize: "0.8rem" }} component="label" htmlFor="pricing-report-card-sort">
        Sort:
      </Typography>
      <Select
        id="pricing-report-card-sort"
        size="small"
        value={selectValue}
        onChange={(event) => onChange(event.target.value)}
        aria-label="Sort card view"
        sx={{ minWidth: 200 }}
      >
        {AGGREGATE_CARD_SORT_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
}

export default PricingReportCardSortSelect;
